import { COLLECTIONS, MOVIES } from '@/shared/data';
import { HeroBillboard } from './components/HeroBillboard';
import { MovieRow } from './components/MovieRow';

export function Home() {
  const trending = COLLECTIONS.find((c) => c.slug === 'trending-now') ?? COLLECTIONS[0];
  const hero = MOVIES.find((m) => m.id === trending.movieIds[0]) ?? MOVIES[0];
  // Next two trending picks form the "fan stack" peek-posters in the hero.
  const peekLeft = MOVIES.find((m) => m.id === trending.movieIds[1]);
  const peekRight = MOVIES.find((m) => m.id === trending.movieIds[2]);
  return (
    <div data-testid="movieflix-home">
      <HeroBillboard movie={hero} peekLeft={peekLeft} peekRight={peekRight} />
      {COLLECTIONS.map((c) => (
        // Continue Watching now uses the same portrait poster variant as the
        // rest of the rows — so it shows the JustWatch posters (m1 = American
        // Horror Story, m3 = Loving, m5 = Je Tere Naal Pyar Na Hunda, m9 =
        // Lie With Me) instead of generic Unsplash backdrops. All rows visually
        // consistent.
        <MovieRow key={c.slug} collection={c} variant="portrait" />
      ))}
    </div>
  );
}
